<template>
  <div
    :class="[
      'relative flex h-[3.75rem] w-full items-start justify-between bg-background p-3',
    ]"
  >
    <div class="flex h-full items-center justify-center">
      <div class="size-8 rounded-lg bg-primary p-1">
        <slot name="icon">
          <component
            :is="icon"
            class="size-full text-background"
          />
        </slot>
      </div>
    </div>
    <div class="ml-3 flex-1">
      <p
        class="line-clamp-1 text-left text-sm font-semibold"
      >
        <slot name="label">
          {{ label }}
        </slot>
      </p>
      <p
        class="line-clamp-1 text-left text-xs text-background-fg/70"
      >
        <slot name="description">
          {{ description }}
        </slot>
      </p>
    </div>
    <div
      class="ml-3 flex h-full items-center justify-center"
    >
      <BaseToggle
        :model-value="modelValue"
        :disabled="disabled"
        @update:model-value="handleToggleUpdate"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Component } from "vue"

const props = defineProps<{
  icon: Component
  label: string
  description?: string
  modelValue: boolean
  disabled?: boolean
  supervisorRequired?: boolean
}>()

const emit = defineEmits<{
  (event: "update:modelValue", value: boolean): void
}>()

const { isSupervisor } = useAuth()
const { reveal: revealSupervisorLoginDrawer } =
  useSupervisorLoginDrawer()

const handleToggleUpdate = async (value: boolean) => {
  if (props.supervisorRequired && !isSupervisor.value) {
    const { isCanceled } =
      await revealSupervisorLoginDrawer()

    if (isCanceled) return
  }

  emit("update:modelValue", value)
}
</script>
